import { Link } from 'react-router-dom';
import { Button } from './ui/button';

interface PopularProduct {
  id: string;
  title: string;
  price: number;
  main_image_url?: string;
  florist_name?: string;
  store_id?: string;
}

interface PopularBunchesProps {
  products?: PopularProduct[];
}

export function PopularBunches({ products = [] }: PopularBunchesProps) {
  // Only show actual featured products, no placeholders
  const displayProducts = products;

  return (
    <section className="w-full py-20 bg-neutral-50">
      <div className="max-w-[1440px] mx-auto px-6">
        <div className="text-left mb-12">
          <h2 className="text-4xl md:text-5xl font-semibold text-brand-secondary tracking-tight mb-3 satoshi-font">
            Popular Bunches
          </h2>
          <p className="text-neutral-600 text-[15px] max-w-2xl satoshi-font">
            Handpicked arrangements from Sydney's finest local florists
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {displayProducts.map((product) => (
            <Link 
              key={product.id} 
              to={product.id.startsWith('placeholder') ? '#' : `/product/${product.id}?florist=${product.store_id || ''}`} 
              className="block group h-full"
            >
              <div className="bg-white rounded-lg overflow-hidden border border-neutral-200 hover:border-neutral-300 hover:scale-[1.01] transition-all duration-200 h-full flex flex-col">
                <div className="aspect-square w-full overflow-hidden flex-shrink-0 bg-neutral-100">
                  <img 
                    src={product.main_image_url || '/images/placeholder-product.jpg'} 
                    alt={product.title} 
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    loading="eager"
                    decoding="async"
                    style={{
                      imageRendering: '-webkit-optimize-contrast',
                      WebkitBackfaceVisibility: 'hidden',
                      transform: 'translateZ(0)'
                    }}
                  />
                </div>
                <div className="p-4 flex-1 flex flex-col">
                  <h3 className="font-medium text-base text-brand-secondary mb-2 line-clamp-2 satoshi-font">
                    {product.title}
                  </h3>
                  <div className="text-xl font-semibold text-brand-primary mb-1">
                    ${product.price.toFixed(2)}
                  </div>
                  {product.florist_name && (
                    <p className="text-sm text-neutral-600 truncate satoshi-font">
                      by {product.florist_name}
                    </p>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
        
        {/* Show More CTA */}
        <div className="text-center mt-12">
          <Button 
            variant="outline" 
            className="border-2 border-brand-primary text-brand-primary bg-[#967F81] hover:bg-[#843329] hover:text-white px-8 py-3 text-base font-semibold rounded-full transition-all duration-200 satoshi-font uppercase tracking-wide"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
              setTimeout(() => {
                const searchInput = document.querySelector('input[placeholder*="suburb"]');
                if (searchInput) {
                  (searchInput as HTMLInputElement).focus();
                }
              }, 500);
            }}
          >
            Show More Bouquets
          </Button>
        </div>
      </div>
    </section>
  );
}
